import { submitContactForm, type SubmitContactFormParams } from "@patient-watch/contact-forms";
import { requiredEnvVars } from "../utils/env";

export function submitGlucoseContactForm(params: SubmitContactFormParams) {
    return submitContactForm(params, {
        supabaseUrl: requiredEnvVars.VITE_SUPABASE_URL,
        supabaseAnonKey: requiredEnvVars.VITE_SUPABASE_ANON_KEY,
    });
}
